var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"center":{lat:10, lng:10},"zoom":7}})}
var staticRenderFns = []

export { render, staticRenderFns }